import { Search, LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PortalHeader({ search, onSearch }) {
  const { user, logout } = useAuth();
  const initials = (user?.name || user?.email || "?")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div
      className="sticky top-20 z-30 backdrop-blur-xl bg-[#0B0C10]/85 border-b border-[#1F2833]"
      data-testid="portal-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center gap-4 flex-wrap">
        <Link to="/" className="shrink-0 flex items-center gap-2">
          <span className="font-display text-[#F5F5F7] text-lg font-bold tracking-tight">
            TraceElements
          </span>
          <span className="h-2 w-2 rounded-full bg-[#FF3355] te-pulse-dot shadow-[0_0_10px_#FF3355]" />
        </Link>

        <div className="inline-flex items-center gap-2 border border-emerald-400/30 bg-emerald-400/5 px-3 py-1.5 rounded-full font-mono text-[10px] uppercase tracking-[0.22em] text-emerald-400">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 te-pulse-dot" />
          system operational
        </div>

        <div className="flex-1 min-w-[220px] relative">
          <Search
            size={14}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[#C5C6C7]/60"
          />
          <input
            data-testid="portal-search"
            type="search"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search projects, assets, services…"
            className="w-full bg-[#0B0C10] border border-[#1F2833] focus:border-[#FF3355] outline-none pl-9 pr-4 py-2.5 font-mono text-xs text-[#F5F5F7] placeholder:text-[#C5C6C7]/40 rounded-sm transition-colors"
          />
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <div className="hidden md:flex flex-col items-end">
            <span className="font-mono text-xs text-[#F5F5F7]">
              {user?.name || "operator"}
            </span>
            <span className="font-mono text-[10px] text-[#C5C6C7]/70">
              {user?.email}
            </span>
          </div>
          <div
            data-testid="portal-avatar"
            className="h-10 w-10 rounded-full border border-[#FF3355]/60 bg-gradient-to-br from-[#B91C2C] to-[#FF3355] flex items-center justify-center font-mono text-xs font-bold text-[#0B0C10]"
          >
            {initials}
          </div>
          <button
            onClick={logout}
            data-testid="portal-logout"
            className="inline-flex items-center gap-2 border border-[#1F2833] hover:border-[#FF3355] text-[#C5C6C7] hover:text-[#FF3355] px-3 py-2 font-mono text-[10px] uppercase tracking-[0.22em] transition-colors"
            title="Sign out"
          >
            <LogOut size={12} />
            <span className="hidden md:inline">sign out</span>
          </button>
        </div>
      </div>
    </div>
  );
}
